import i18n from '@/locales/index.js';
import createTemplateBtn from './pages/templates/list/components/create-template-button';
import createCampaignBtn from './pages/campaigns/list/components/create-campain-button';
import ChatHeaderButtons from './pages/chats/components/header-buttons.vue';
import AnalyticsFilter from './pages/analytics/components/filter.vue';

import categoryButtons from './pages/categories/list/components/categoryButtons';
import { hasMarketplace, marketplacesEnum } from '../../utils/marketplaces';

const whatsappRoutes = {
	path: 'whatsapp',
	component: () => import('./module-layout.vue'),
	redirect: () => {
		return '/v2/whatsapp/chats';
	},
	meta: {
		can: () => {
			return (
				hasMarketplace(marketplacesEnum.WhatsApp) ||
				hasMarketplace(marketplacesEnum.Instagram) ||
				hasMarketplace(marketplacesEnum.WhatsAppQR) ||
				hasMarketplace(marketplacesEnum.Messenger) ||
				'/v2/integrations/marketplaces'
			);
		},
	},
	children: [
		//begin::templates
		{
			path: 'templates/:type/update/:id',
			name: 'whatsapp-templates-update',
			component: () => import('./pages/templates/create-edit/index.vue'),
			props: true,
			meta: {
				title: ({ route }) => i18n.global.t(`templates.update.${route.params.type}`),
			},
		},
		{
			path: 'templates/:type/create',
			name: 'create-new-template',
			component: () => import('./pages/templates/create-edit/index.vue'),
			props: true,
			meta: {
				title: ({ route }) => i18n.global.t(`templates.create.${route.params.type}`),
			},
		},
		{
			path: 'templates',
			name: 'whatsapp-templates',
			component: () => import('./pages/templates/list/index.vue'),
			meta: {
				title: i18n.global.t('templates.title'),
				headerExtraComponent: createTemplateBtn,
			},
		},
		//end::templates
		//begin::Campaigns
		{
			path: 'campaigns/update/:id',
			name: 'whatsapp-update-campaign',
			component: () => import('./pages/campaigns/create-edit/index.vue'),
			props: true,
			meta: {
				title: i18n.global.t(`campaigns.update`),
			},
		},
		{
			path: 'campaigns/create',
			name: 'whatsapp-create-campaign',
			component: () => import('./pages/campaigns/create-edit/index.vue'),
			props: true,
			meta: {
				title: i18n.global.t(`campaigns.create`),
			},
		},
		{
			path: 'campaigns',
			name: 'whatsapp-campaigns',
			component: () => import('./pages/campaigns/list/index.vue'),
			meta: {
				title: i18n.global.t('campaigns.title'),
				headerExtraComponent: createCampaignBtn,
			},
		},
		{
			path: 'campaigns/:id/performance',
			name: 'whatsapp-campaign-performance',
			component: () => import('./pages/campaigns/performance/index.vue'),
			props: true,
			meta: {
				title: i18n.global.t('campaigns.other.campaignPerformance'),
			},
		},
		//end::Campaigns
		//begin::Manage Labels
		// {
		//     path: 'manage-labels',
		// 	name: 'whatsapp-manage-labels',
		// 	component: () => import('./pages/labels/list/index.vue'),
		// 	meta: {
		//         title: i18n.global.t('whatsapp.manage-labels'),
		// 	},
		// },
		//end::Manage Labels

		{
			path: 'chats',
			name: 'whatsapp-chat',
			component: () => import('./pages/chats/index.vue'),
			meta: {
				title: i18n.global.t('whatsapp.inbox'),
				headerExtraComponent: ChatHeaderButtons,
			},
		},
		{
			path: 'settings',
			name: 'settings',
			component: () => import('./pages/settings/index.vue'),
			meta: {
				title: i18n.global.t('whatsapp.inbox-settings'),
			},
		},

		//begin::categories
		{
			path: 'categories',
			name: 'whatsapp-categories',
			component: () => import('./pages/categories/list/index.vue'),
			meta: {
				title: i18n.global.t('whatsapp.whatsapp-categories'),
				headerExtraComponent: categoryButtons,
			},
		},
		//end::categories

		{
			path: 'analytics',
			name: 'whatsapp-analytics',
			component: () => import('./pages/analytics/index.vue'),
			meta: {
				title: i18n.global.t('whatsapp.whatsappAnalytics'),
				headerExtraComponent: AnalyticsFilter,
			},
		},
	],
};

export { whatsappRoutes };
